import React from 'react';

const Attachments = () => {
  return (
    <svg width="109" height="60" viewBox="0 0 109 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="43.8489" y="39" width="38.8481" height="4" fill="#C1C3C6" />
      <rect x="43.8489" y="46" width="12.5316" height="4" fill="#E6E9EC" />
      <ellipse cx="25.0502" cy="45" rx="8.77215" ry="7" fill="#4E40EF" />
      <g filter="url(#filter0_d)">
        <rect x="5" y="20" width="99" height="33" rx="6" fill="white" />
        <rect x="4.75" y="19.75" width="99.5" height="33.5" rx="6.25" stroke="#E6E9EC" strokeWidth="0.5" />
      </g>
      <rect x="34" y="35" width="31" height="4" fill="#E6E9EC" />
      <rect x="83" y="35" width="10" height="4" fill="#E6E9EC" />
      <path
        d="M15.75 42.75H23.25C23.5815 42.75 23.8995 42.6183 24.1339 42.3839C24.3683 42.1495 24.5 41.8315 24.5 41.5V31.5C24.5 31.1685 24.3683 30.8505 24.1339 30.6161C23.8995 30.3817 23.5815 30.25 23.25 30.25H18.7687C18.6038 30.2499 18.4405 30.2824 18.2881 30.3457C18.1358 30.409 17.9975 30.5018 17.8812 30.6188L14.8688 33.6313C14.7518 33.7475 14.659 33.8858 14.5957 34.0381C14.5324 34.1905 14.4999 34.3538 14.5 34.5188V41.5C14.5 41.8315 14.6317 42.1495 14.8661 42.3839C15.1005 42.6183 15.4185 42.75 15.75 42.75ZM18.875 31.3875V34C18.875 34.1658 18.8092 34.3247 18.6919 34.4419C18.5747 34.5592 18.4158 34.625 18.25 34.625H15.6375L18.875 31.3875Z"
        fill="#E6E9EC"
      />
      <rect x="43.8489" y="22" width="38.8481" height="4" fill="#C1C3C6" />
      <rect x="43.8489" y="29" width="12.5316" height="4" fill="#E6E9EC" />
      <ellipse cx="25.0502" cy="28" rx="8.77215" ry="7" fill="#4E40EF" />
      <g filter="url(#filter1_d)">
        <rect x="5" y="3" width="99" height="33" rx="6" fill="white" />
        <rect x="4.75" y="2.75" width="99.5" height="33.5" rx="6.25" stroke="#E6E9EC" strokeWidth="0.5" />
      </g>
      <rect x="34" y="18" width="31" height="4" fill="#E6E9EC" />
      <rect x="83" y="18" width="10" height="4" fill="#E6E9EC" />
      <path
        d="M15.75 25.75H23.25C23.5815 25.75 23.8995 25.6183 24.1339 25.3839C24.3683 25.1495 24.5 24.8315 24.5 24.5V14.5C24.5 14.1685 24.3683 13.8505 24.1339 13.6161C23.8995 13.3817 23.5815 13.25 23.25 13.25H18.7687C18.6038 13.2499 18.4405 13.2824 18.2881 13.3457C18.1358 13.409 17.9975 13.5018 17.8812 13.6188L14.8688 16.6313C14.7518 16.7475 14.659 16.8858 14.5957 17.0381C14.5324 17.1905 14.4999 17.3538 14.5 17.5188V24.5C14.5 24.8315 14.6317 25.1495 14.8661 25.3839C15.1005 25.6183 15.4185 25.75 15.75 25.75ZM18.875 14.3875V17C18.875 17.1658 18.8092 17.3247 18.6919 17.4419C18.5747 17.5592 18.4158 17.625 18.25 17.625H15.6375L18.875 14.3875Z"
        fill="#4E40EF"
      />
      <defs>
        <filter
          id="filter0_d"
          x="0.5"
          y="17.5"
          width="108"
          height="42"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <filter
          id="filter1_d"
          x="0.5"
          y="0.5"
          width="108"
          height="42"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export default Attachments;
